import React from "react";

type NoAvailableProps = {
  classNameContainer?: string,
  className?: string,
  text?: string
};

const NoAvailable: React.FC<NoAvailableProps> = ({
  classNameContainer,
  className,
  text,
}) => {
  return (
    <div className={`${classNameContainer || ''}`}>
      <p className={`${className || ''}`}>Sorry, no {text || 'data'} available</p>
    </div>
  );
};

export default NoAvailable;
